export default __webpack_public_path__ + "static/media/fatt-logo.adff9fc8.jpeg";